const humanitiesFirstBaccalaureateOptions = [
  'الأولى بكالوريا علوم شرعية',
  'الأولى بكالوريا خيار اللغة العربية',
  'الأولى بكالوريا آداب وعلوم إنسانية خيار الفرنسية',
  'الأولى بكالوريا آداب وعلوم إنسانية خيار الإنجليزية',
  'الأولى بكالوريا آداب وعلوم إنسانية خيار الإسبانية',
  'الأولى بكالوريا خيار الفنون التطبيقية',
  'الأولى بكالوريا آداب وعلوم إنسانية مسلك الرياضة والتربية البدنية',
  'الأولى بكالوريا العلوم الاقتصادية والتدبير',
  'الأولى بكالوريا مسالك البكالوريا المهنية الخدماتية',
  'الأولى بكالوريا الفنون التطبيقية',
];

const scienceFirstBaccalaureateOptions = [
  'الأولى بكالوريا علوم تجريبية خيار الفرنسية',
  'الأولى بكالوريا علوم تجريبية خيار الإنجليزية',
  'الأولى بكالوريا علوم تجريبية خيار الإسبانية',
  'الأولى بكالوريا علوم رياضية خيار الفرنسية',
  'الأولى بكالوريا علوم رياضية خيار الإنجليزية',
  'الأولى بكالوريا علوم رياضية خيار الإسبانية',
  'الأولى بكالوريا العلوم والتكنولوجيات الميكانيكية',
  'الأولى بكالوريا العلوم والتكنولوجيات الكهربائية',
  'الأولى بكالوريا العلوم الاقتصادية والتدبير',
  'الأولى بكالوريا الفنون التطبيقية',
  'الأولى بكالوريا مسالك البكالوريا المهنية (الصناعية، الفلاحية، وبعض الخدماتية)',
  'الأولى بكالوريا علوم تجريبية مسلك الرياضة والتربية البدنية',
];

const firstBaccalaureateOptionsByBranchLabel = {
  'الجذع المشترك الأصيل': humanitiesFirstBaccalaureateOptions,
  'جذع مشترك الآداب والعلوم الإنسانية': humanitiesFirstBaccalaureateOptions,
 'الجذع المشترك للآداب والعلوم الإنسانية – خيار فرنسية': humanitiesFirstBaccalaureateOptions,  'جذع المشترك للآداب والعلوم الإنسانية – خيار إنجليزية': humanitiesFirstBaccalaureateOptions,
  'جذع المشترك للآداب والعلوم الإنسانية – خيار إسبانية': humanitiesFirstBaccalaureateOptions,
  'الجذع المشترك العلمي': scienceFirstBaccalaureateOptions,
  'الجذع المشترك العلمي – خيار فرنسية': scienceFirstBaccalaureateOptions,
  'الجذع المشترك العلمي – خيار إنجليزية': scienceFirstBaccalaureateOptions,
  'الجذع المشترك العلمي – خيار إسبانية': scienceFirstBaccalaureateOptions,
  'الجذع المشترك التكنولوجي': scienceFirstBaccalaureateOptions,
};

export const getFirstBaccalaureateOptions = (branchLabel) =>
  firstBaccalaureateOptionsByBranchLabel[branchLabel] || [];
